import React from 'react';
import './social_btn.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SocialBtn = ({ link, handle, icon, variant }) => {
    return (
        <a href={link} className={`social-btn ${variant}`} target="_blank" rel="noopener noreferrer">
            <div className="icon-container">
                <FontAwesomeIcon icon={icon} />
            </div>
            <span className="handle-text">{handle}</span>
        </a>
    );
};

export default SocialBtn;
